/*
  temporary duplicate of some Team lib methods
  for subs incubator
*/
import { createResource } from '../../../shared/lib/createResource';
import { useCurrentTeamId } from '../../../shared/artists/src/useCurrentTeamId';
import { useArtist } from '../../../shared/artists/src/useArtist';
import {
  WEBGATE_DOMAIN,
  MARKETPLACE_MGMT_API,
  webgateFetchJson,
} from '../../../shared/lib/api';
import { Checkout, Purchase, PurchaseResponse } from '../types';

export const WALLET_API = `${WEBGATE_DOMAIN}/s4x-wallet`;
const BILLING_API = `${WEBGATE_DOMAIN}/s4x-billing`;

export type OrganizationResponse = {
  uri: string;
  name: string;
  imageUrl: string;
};

export type Organization = {
  id: string;
  uri: string;
  name: string;
  imageUrl: string;
  type: string;
};

const TeamManagementOrganizationsResource = createResource<
  number,
  Organization[]
>(() =>
  webgateFetchJson(`${MARKETPLACE_MGMT_API}/v1/team/manageteam`).then(
    (organizations: OrganizationResponse[]) =>
      organizations.map(formatOrganization),
  ),
);

function formatOrganization(organization: OrganizationResponse): Organization {
  return {
    id: organization.uri.split(':')[2],
    type: organization.uri.split(':')[1],
    ...organization,
  };
}

export const useCurrentOrg = () => {
  const teamId = useCurrentTeamId();
  return useArtist(teamId);
};

export const useTeamManagementOrganizations = () => {
  return TeamManagementOrganizationsResource.read(0);
};

// temp helper methods to communicate with subs endpoints

export async function createSubscriptionCheckout(
  artistId: string,
  checkoutId: string,
): Promise<Checkout> {
  const result: Checkout = await webgateFetchJson(
    `${WALLET_API}/v1/artist/${artistId}/checkout/${checkoutId}`,
  );
  return result;
}

export async function purchaseSubscription(
  artistId: string,
  purchase: Purchase,
): Promise<PurchaseResponse> {
  const payload = {
    method: 'POST',
    body: JSON.stringify(purchase),
  };

  const result: PurchaseResponse = await webgateFetchJson(
    `${BILLING_API}/v1/artist/${artistId}/purchase`,
    payload,
  );

  return result;
}

export async function cancelSubscription(artistId: string): Promise<boolean> {
  const result: boolean = await webgateFetchJson(
    `${BILLING_API}/v1/artist/${artistId}/purchase`,
    { method: 'DELETE' },
  );

  return result;
}

export const validateCheckoutAndRedirect: (
  artistId: string,
) => Promise<void> = async artistId => {
  const result = await webgateFetchJson(
    `${WALLET_API}/v1/artist/${artistId}/checkout`,
    { method: 'POST' },
  );
  window.location.replace(result.redirectUrl);
};
